import * as types from "../actions/actionTypes";

const STORAGE_PREFIX = "requests:"; // + session code: the songs this device asked for there
const MAX_ASKED = 100;

const readStoredCode = () => {
  try {
    return localStorage.getItem("sessionCode") || null;
  } catch {
    return null;
  }
};

const readAsked = (code) => {
  if (!code) return [];
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_PREFIX + code) || "[]");
    return Array.isArray(stored) ? stored.filter((id) => Number.isInteger(id)) : [];
  } catch {
    return [];
  }
};

const storeAsked = (code, songIds) => {
  if (!code) return;
  try {
    if (songIds.length) localStorage.setItem(STORAGE_PREFIX + code, JSON.stringify(songIds));
    else localStorage.removeItem(STORAGE_PREFIX + code);
  } catch {
    // storage unavailable: the device forgets what it asked for on reload
  }
};

// Guests' song requests for the current session, oldest first (the host acts on them,
// everyone sees them), and the songs this device asked for, kept per session on the device.
export const initialRequestsState = { items: [], isLoaded: false, mine: [], code: null };

// A function so the remembered session's list is read when the store is created.
export const createInitialRequestsState = () => {
  const code = readStoredCode();
  return { ...initialRequestsState, code, mine: readAsked(code) };
};

const byTime = (a, b) => new Date(a.Requested) - new Date(b.Requested) || a.Id - b.Id;

export default function requestsReducer(state = createInitialRequestsState(), action) {
  switch (action.type) {
    case types.REQUESTS_LOAD_SUCCESS:
      return { ...state, items: [...(action.requests || [])].sort(byTime), isLoaded: true };

    case types.REQUEST_ADDED: {
      if (!action.request) return state;
      // a vote arrives as the same request with a new count, so this replaces as well as adds
      const others = state.items.filter((request) => request.Id !== action.request.Id);
      return { ...state, items: [...others, action.request].sort(byTime) };
    }

    case types.REQUEST_REMOVED: {
      const gone = state.items.find((request) => request.Id === action.requestId);
      const items = state.items.filter((request) => request.Id !== action.requestId);
      const mine = state.mine || [];
      // once the host has dealt with it, this device may ask for the song again
      if (!gone || !mine.includes(gone.SongId)) return { ...state, items };
      const rest = mine.filter((songId) => songId !== gone.SongId);
      storeAsked(state.code, rest);
      return { ...state, items, mine: rest };
    }

    case types.REQUEST_ASKED: {
      const mine = state.mine || [];
      const has = mine.includes(action.songId);
      if (action.asked === false ? !has : has) return state;
      const next = action.asked === false ? mine.filter((songId) => songId !== action.songId) : [...mine, action.songId].slice(-MAX_ASKED);
      storeAsked(state.code, next);
      return { ...state, mine: next };
    }

    case types.SONG_DELETED:
      return { ...state, items: state.items.filter((request) => request.SongId !== action.songId) };

    case types.SESSION_SET_CODE:
      return { ...initialRequestsState, code: action.code, mine: readAsked(action.code) };

    case types.SESSION_CLEAR:
      return initialRequestsState;

    default:
      return state;
  }
}
